type Options = {
  prefix?: string;
  suffix?: string;
  min?: number;
  max?: number;
};

export const formatnumber = (
  number?: number | string,
  { prefix = "", suffix = "", min = 0, max = 0 }: Options = {},
) => {
  if (typeof number === "number") {
    const roundedNumber =
      Math.round(
        (number >= 0 ? number + Number.EPSILON : number - Number.EPSILON) * 100,
      ) / 100;
    return (
      prefix +
      roundedNumber.toLocaleString("en-US", {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
      }) +
      suffix
    );
  }

  return number;
};
